import { faTimes, faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@ui';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import useModalManagerStore, { ModalWithId } from './useModalManagerStore';

const CloseConfirmTitle = () => {
    const { t } = useTranslation('common');
    return <>{t('confirmation.discardTitle')}</>;
};

const CloseConfirm = ({ message, onCancel, onDiscard }: { message: ReactNode; onCancel: () => void; onDiscard: () => void }) => {
    const { t } = useTranslation('common');

    return (
        <>
            <p className="tw-mb-4 tw-mt-2">{true === message ? t('confirmation.discardMessage') : message}</p>
            <div className="tw-flex tw-w-full tw-justify-end tw-gap-2">
                <Button flat size="sm" color="light" onPress={onCancel} icon={<FontAwesomeIcon icon={faTimes} />}>
                    {t('actions.cancel')}
                </Button>
                <Button flat size="sm" color="error" onPress={onDiscard} icon={<FontAwesomeIcon icon={faTrash} />}>
                    {t('actions.discard')}
                </Button>
            </div>
        </>
    );
};

// the × keeps focus under the confirm, so a second Enter would stack another one
const openConfirms = new Map<string, string>();

/** × and Escape both land here, so a guarded modal asks the same way for either. */
export const requestModalClose = (modal: ModalWithId) => {
    const { addModal, removeModal, modals } = useModalManagerStore.getState();
    const close = () => {
        modal.onClose?.();
        removeModal(modal.id);
    };

    if (!modal.confirmClose) return close();
    const confirmId = openConfirms.get(modal.id);
    if (confirmId && modals.some((m) => m.id === confirmId)) return;

    addModal({
        title: <CloseConfirmTitle />,
        size: 30,
        content: (id) => {
            openConfirms.set(modal.id, id);
            return (
                <CloseConfirm
                    message={modal.confirmClose}
                    onCancel={() => removeModal(id)}
                    onDiscard={() => {
                        openConfirms.delete(modal.id);
                        removeModal(id);
                        close();
                    }}
                />
            );
        }
    });
};
